
//const context = 'DEBUG';
const context = 'PROD'

if (context == 'DEBUG')
{
  // Debug configuration

  module.exports = {
    API_ROOT: "https://test.infodemics.com/",
    cipher: "schrodinger",
    defaultPassword: "Newtons3rdLaw",
    ABLY_API_KEY: "Ky_auw.AfRiww:YJstrYf16bdmv2sA",
    firebaseConfig: {
      apiKey: "AIzaSyB8i7ioVBYvP5FQuqWaaq0wraFRt5eBDO8",
      authDomain: "infodemics-web-ui.firebaseapp.com",
      databaseURL: "https://infodemics-web-ui.firebaseio.com",
      projectId: "infodemics-web-ui",
      storageBucket: "infodemics-web-ui.appspot.com",
      messagingSenderId: "247130536457",
      appId: "1:247130536457:web:6152e5e324886f26aed6d8"
    },
    firebaseDefaultUser: {
      email: "heisenberg@infodemics.com",
      password: "schrodinger"
    },
    GMapKey: "AIzaSyDS8npEalSNuWIE12XJ3tQ3CsV6q8Tj0RI",
    auth0: {
      domain: 'infodemics.auth0.com',
      clientID: 'WfaZmRipLVfVR0nL8P92GMEuF_DtdAGv',
      redirectUri: 'https://petri.infodemics.com/callback',
      responseType: 'token id_token',
      scope: 'openid profile email'
    }
  };
}
else
{
  // Production config. To use this configuration, uncomment it and comment out the debug configuration

  module.exports = {
    API_ROOT: "https://live.infodemics.com/",
    cipher: "schrodinger",
    defaultPassword: "Newtons3rdLaw",
    ABLY_API_KEY: "iRN6LA.ve9G6A:XlNdGCJ4H2hwe51K",
    firebaseConfig: {
      apiKey: "AIzaSyAcO5C6bIE4qvT7V5-vzz3iv-7McBMooJQ",
      authDomain: "infodemics-web-ui-live.firebaseapp.com",
      databaseURL: "https://infodemics-web-ui-live.firebaseio.com",
      projectId: "infodemics-web-ui-live",
      storageBucket: "infodemics-web-ui-live.appspot.com",
      messagingSenderId: "832564475031",
      appId: "1:832564475031:web:ae4030767a929cf75fe5d2"
    },
    firebaseDefaultUser: {
      email: "uploads@infodemics.com",
      password: "ingenia"
    },
    GMapKey: "AIzaSyDS8npEalSNuWIE12XJ3tQ3CsV6q8Tj0RI",
    auth0: {
      domain: 'infodemics.auth0.com',
      clientID: 'ifiojHFvFGL5EWzMAsijVyf3Nt7v60dg',
      redirectUri: 'https://infodemics.com/callback',
      responseType: 'token id_token',
      scope: 'openid profile email'
    }
  };
}